import { render, staticRenderFns } from "./q8.vue?vue&type=template&id=2eca46de&scoped=true&"
import script from "./q8.vue?vue&type=script&lang=js&"
export * from "./q8.vue?vue&type=script&lang=js&"
import style0 from "./q8.vue?vue&type=style&index=0&id=2eca46de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca46de",
  null
  
)

export default component.exports